export default __webpack_public_path__ + "dd147f400407c74adec7031be0824dc7.png";